// extracted by mini-css-extract-plugin
export default {"root":"msvcD7","wrapper":"yEeZT_","open":"BDv5XH","appear":"ETblEo","fullScreen":"POIjkx","popover":"xhEhU0"};